import React, { FC } from 'react'

import { Typography } from '@material-ui/core'
import { Property, PropertyUnit } from '@/types/reservation'

interface Props {
    readonly propertyUnit?: PropertyUnit;
    readonly property?: Property;
}

const PropertyInfo: FC<Props> = ({
                                     propertyUnit,
                                     property,
                                 }) => {
    const propertyName = property?.name || null
    const apartmentCategory = propertyUnit?.name || null
    const apartmentNumber = propertyUnit?.number || null
    const apartmentFloor = propertyUnit?.floorNumber || null

    return (
        <div>
            <h2>Property</h2>
            <Typography>
                {`Name: ${propertyName || '--'}`}
            </Typography>
            <Typography>
                {`Apartment category: ${apartmentCategory || '--'}`}
            </Typography>
            <Typography>
                {`Floor/number: ${ apartmentFloor || '--' } / ${ apartmentNumber || '--' }`}
            </Typography>
        </div>
    )
}

export default PropertyInfo
